module.exports = __webpack_public_path__ + "static/media/famila-512.ed18543a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/famila-512.png
// module id = 768
// module chunks = 0